import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// Define the structure for departments, including 'id' for content mapping
// and 'name' for display in the sidebar.
const departments = [
    { "name": "परिचय", "id": "about" },
    { "name": "संचालित पाठ्यक्रम", "id": "courses" }, // Added missing courses section
    { "name": "संकाय सदस्य", "id": "faculty" },
    { "name": "समय सारिणी", "id": "timetable" },
    { "name": "सुविधाएं", "id": "facilities" },
    { "name": "सेमीनार/सम्मेलन/कार्यशाला", "id": "events" },
    { "name": "शोधच्छात्र", "id": "researchScholars" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

// Content for each section, mapped by their 'id'
const departmentContent = {
    "about": (
        <div>
            <p className="mb-2">हिन्दू अध्ययन विभाग में हिन्दू धर्म, संस्कृति, दर्शन, साहित्य, इतिहास एवं कला का अध्ययन किया जाता है। हिन्दूत्व का सम्यक् ज्ञान एवं हिन्दू पद्धतियों के प्रति छात्रों की समझ को विकसित करने हेतु हिन्दू अध्ययन विभाग कार्य करता है। विभाग का मुख्य उद्देश्य हिन्दूत्व के विभिन्न पहलुओं का अध्ययन करना, हिन्दू दर्शन, हिन्दू संस्कृति कला, इतिहास, भारतीय ज्ञान, परम्परा का ज्ञान, संस्कृत भाषा का मौलिक ज्ञान करवाकर छात्रों में हिन्दूत्व (सनातन) की समझ विकसित करना है।</p>
            <p className="mb-2">वर्तमान में विश्वविद्यालय में केवल स्नात्कोत्तर (एम.ए.) पाठ्यक्रम लागू है। जिसमें प्रवेश के लिए किसी भी विषय में स्नातक होना आवश्यक है। पाठ्यक्रम दो वर्ष (चार सत्र) का है, प्रत्येक सत्र में प्रश्न पत्र होते हैं। प्रत्येक पत्र 4 क्रेडिट का है।</p>
        </div>
    ),
    "courses": ( // Content for the newly added courses section
        <div>

            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">स्नातकोत्तर (एम.ए.) हिन्दू अध्ययन</li>
            </ul>
            <h6 className="mt-4 mb-2">पाठ्यक्रम प्रवेश अर्हता:</h6>
            <p>किसी भी विषय में स्नातक डिग्री (Bachelor's Degree in any discipline).</p>
            <p>पाठ्यक्रम की अवधि: 2 वर्ष (4 सेमेस्टर).</p>
        </div>
    ),
    "faculty": (
        <div className="mb-4">

            <h6 className="mb-3">1. कुल शिक्षक - 2</h6>

            {/* नियमित शिक्षक */}

            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small mb-4">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>क्र.</th>
                            <th>फोटो</th>
                            <th>प्रोफेसर का नाम</th>
                            <th>पद</th>
                            <th>उच्चतम योग्यता</th>
                            <th>संपर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td>1.</td>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. कृष्ण चन्द्र पाण्डे (विभागाध्यक्ष, हिन्दू अध्ययन).JPG")}
                                    alt="डॉ. कृष्णचन्द पाण्डे"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. कृष्णचन्द पाण्डे</td>
                            <td>विभागाध्यक्ष, सहायक-आचार्य</td>
                            <td>पी.एच.डी.</td>
                            <td>98103 73278</td>
                            <td>
                                <a href="mailto:hodhindustudies@mvsu.ac.in">
                                    hodhindustudies@mvsu.ac.in
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* अनुबंधित शिक्षक */}

            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>क्र.</th>
                            <th>फोटो</th>
                            <th>प्रोफेसर का नाम</th>
                            <th>पद</th>
                            <th>उच्चतम योग्यता</th>
                            <th>संपर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td>1.</td>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. हरीश कुमार (हिन्दु अध्ययन).jpg")}
                                    alt="डॉ. हरीश कुमार"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. हरीश कुमार</td>
                            <td>सहायक-आचार्य</td>
                            <td>पी.एच.डी.</td>
                            <td>79883 76657</td>
                            <td>
                                <a href="mailto:rishibhawan@gmail.com">
                                    rishibhawan@gmail.com
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),


    "timetable": (
        <div>
            <p>समय सारिणी संबंधित जानकारी शीघ्र ही उपलब्ध कराई जाएगी।</p>
        </div>
    ),
    "facilities": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0"> छात्रों को वैषयिक ज्ञान के साथ प्रायोगिक ज्ञान प्रदान किया जाता है। </li>
                <li className="list-group-item bg-transparent border-0">विविध प्रतियोगी परीक्षाओं का प्रशिक्षण प्रदान किया जाता है, जैसे – यू.जी.सी. नेट परीक्षा, CTET, B.Ed., T.G.T (Sanskrit), P.G.T (Sanskrit), धर्मगुरु हेतु प्रशिक्षण इत्यादि।</li>
            </ul>
        </div>
    ),
    "events": (
        <div>
            <h6 className="mb-2 mt-4 text-secondary">* व्याख्यानमाला -</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">दिनांक 15 मार्च 2024 को महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल एवं भारतीय भाषा समिति के संयुक्त तत्वावधान में “भारत की सांस्कृतिक एकात्मता में शंकराचार्य का योगदान” विषय पर आयोजित व्याख्यानमाला में मुख्य वक्ता डॉ. चितरंजन दयाल कौशल, (निदेशक, हरियाणा साहित्य संस्कृति अकादमी संस्कृत प्रकोष्ठ), मुख्य अतिथि महामण्डलेश्वर स्वामी विरागानन्द गिरि जी अध्यक्ष विश्वविद्यालय के माननीय कुलपति प्रो. रमेश चन्द्र भारद्वाज जी रहे। कार्यक्रम का संयोजन डॉ. कृष्ण चन्द्र पाण्डे (विभागाध्यक्ष, हिन्दू अध्ययन विभाग) ने किया।</li>
                <li className="list-group-item bg-transparent border-0">25 जनवरी 2025 को "संविधान के 75 वर्ष" के उपलक्ष्य में भारतीय संविधान, गणतंत्र परंपरा और आधुनिकता के महत्व और संविधान पर गर्व करने के लक्ष्यों को लेकर एक विशेष कार्यक्रम आयोजित किया गया। कार्यक्रम के संरक्षक एवं विश्वविद्यालय के कुलपति प्रो. रमेश चन्द्र भारद्वाज, मुख्य वक्ता प्रो. संजीव कुमार शर्मा, पूर्व कुलपति, महात्मा गांधी केन्द्रीय विश्वविद्यालय, मोतीहार, बिहार, शैक्षणिक अधिष्ठाता प्रो. सत्य प्रकाश दुबे, विश्वविद्यालय के कुलसचिव डॉ. बृजपाल, कार्यक्रम के संयोजक हिन्दू अध्ययन विभाग के अध्यक्ष डॉ. कृष्ण चन्द्र पाण्डेय तथा कार्यक्रम का संचालक एवं सह-संयोजक डॉ. गोविन्द वल्लभ रहे।</li>
            </ol>
            <h6 className="mb-2 mt-4 text-secondary">* प्रतियोगिताऐं -</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">दिनांक 16-09-2022 को महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल में विश्व ओजोन दिवस के उपलक्ष्य में “पृथ्वी पर जीवन संरक्षण को लेकर वैश्विक सहयोग” विषय पर स्लोगन व लेखन प्रतियोगिता करवाई गई, जिसमें 100 विद्यार्थियों ने भाग लिया। जिसमें प्रथम, द्वितीय एवं तृतीय स्थान प्राप्त करने वाले विद्यार्थियों को प्रमाण पत्र से पुरस्कृत किया गया।</li>
                <li className="list-group-item bg-transparent border-0">25 जनवरी 2025 को कार्यक्रम में “हमारा संविधान हमारा गौरव” विषय पर आयोजित निबन्ध प्रतियोगिता की गई तथा उन्हें मुख्य अतिथि द्वारा प्रमाण-पत्र तथा सम्मान राशि प्रदान की गई। राष्ट्रगान के साथ कार्यक्रम का समापन हुआ। इस अवसर पर विश्वविद्यालय के सभी विभागाध्यक्ष, प्राध्यापक एवं विद्यार्थी उपस्थित रहे। कार्यक्रम के संयोजक हिन्दू अध्ययन विभाग के अध्यक्ष डॉ. कृष्ण चन्द्र पाण्डेय तथा कार्यक्रम का संचालक एवं सह-संयोजक डॉ. गोविन्द वल्लभ रहे।</li>
            </ol>
            <h6 className="mb-2 mt-4 text-secondary">* शैक्षणिक भ्रमण -</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के हिन्दू अध्ययन विभाग एवं शोध विभाग के छात्रों ने संयोजक एवं हिन्दू अध्ययन विभाग के अध्यक्ष डॉ. कृष्ण चन्द्र पाण्डे के सानिध्य में हरियाणा के प्रसिद्ध प्राचीन ऐतिहासिक और सांस्कृतिक पर्यटन स्थल आदिबद्री और कपाल मोचन तीर्थस्थल, यमुनानगर जिले का भ्रमण किया। छात्रों के साथ, डॉ. कुलदीप एवं डॉ. शर्मिला भी रहे।</li>
                <li className="list-group-item bg-transparent border-0">दिनांक 18.11.2023 को हिन्दू अध्ययन के विभागाध्यक्ष डॉ. कृष्ण चन्द्र पाण्डे, डॉ. शर्मिला एवं डॉ. नवीन शर्मा के सान्निध्य में हिन्दू अध्ययन विभाग के छात्रों को गुहला, चीका क्षेत्र में स्थापित शिव कैलाश ग्रीन एनर्जी औद्योगिक संस्थान में शैक्षणिक भ्रमण के लिए ले जाया गया।</li>
                <li className="list-group-item bg-transparent border-0">दिनांक 23.04.25 को आदिबद्रीनाथ एवं कपालमोचन, यमुनानगर के लिए हिन्दू अध्ययन विभाग के छात्रों के एक दिवसीय शैक्षणिक भ्रमण का आयोजन किया गया। जिसके संयोजक हिन्दू अध्ययन विभाग के अध्यक्ष डॉ. कृष्ण चन्द्र पाण्डेय रहे।</li>
            </ol>
        </div>
    ),
    "researchScholars": (
        <div>
            <p>शोधच्छात्र व विद्यावारिधि उपाधि हेतु पंजीकृत छात्र नहीं हैं।</p>
        </div>
    ),
    "achievements": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">हिन्दू अध्ययन विभाग के वर्ष 2022-23 में 31 एवं वर्ष 2023-24 में 19 विद्यार्थियों ने उपाधि ग्रहण की।</li>
                <li className="list-group-item bg-transparent border-0">हिन्दू अध्ययन विभाग से 08 छात्र/छात्राओं ने NET की परीक्षा एवं 02 छात्र ने JRF की परीक्षा उतीर्ण कर विश्वविद्यालय के साथ-साथ हिन्दू अध्ययन विभाग का भी नाम रोशन किया।</li>
            </ul>
        </div>
    ),
    "contact": (
        <div>
            <h5 className="mb-3">विभाग में कार्यरत शैक्षणिक कर्मचारियों का विवरण</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small mb-4">
                    <thead className="table-dark">
                        <tr>
                            <th>क्रं.सं.</th>
                            <th>नाम</th>
                            <th>पद</th>
                            <th>दूरभाष</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>डॉ. कृष्णचन्द्र पाण्डे</td>
                            <td>विभागाध्यक्ष, हिन्दू अध्ययन (नियमित)</td>
                            <td>98103-73278</td>
                            <td>hodhindustudies@mvsu.ac.in</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>डॉ. हरीश कुमार</td>
                            <td>सहायक आचार्य (अनुबन्ध)</td>
                            <td>79883-76657</td>
                            <td>rishibhawn@gmail.com</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p className="mb-4 fw-bold"> विभाग में कार्यरत सहायक आचार्य (अंशकालिक) - अभी कोई नहीं है।</p>
            <h5 className="mb-3">विभाग में कार्यरत गैर-शैक्षणिक कर्मचारियों का विवरण</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>क्र.</th>
                            <th>कर्मचारी का नाम</th>
                            <th>पद</th>
                            <th>दूरभाष</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>कमल आनन्द</td>
                            <td>टाईपिस्ट</td>
                            <td>98026-00325</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default function DepartmentHinduStudies() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about"); // Set initial content to "about" (परिचय)

    // Helper to find the display name of the active section
    const getActiveSectionName = () => {
        const activeDept = departments.find(dept => dept.id === activeContentId);
        return activeDept ? activeDept.name : "विभाग"; // Default to 'विभाग' if not found
    };

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        // Hide sidebar on click for small screens
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>



            {/* Sidebar */}
            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">हिंदू अध्ययन विभाग</h5>
                <nav className="flex-grow-1 overflow-auto pe-2"> {/* Added pe-2 for right padding on scrollbar */}
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded small cursor-pointer transition-colors ${activeContentId === dept.id ? "text-white shadow-sm" : "bg-light text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : undefined,
                                fontWeight: activeContentId === dept.id ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </nav>
            </aside>


            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">

                <h4 className="mb-3  text-center" style={{ color: '#77236b' }}>{getActiveSectionName()}</h4>

                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>

            {/* Inline CSS for transition effect and hover effect */}
            <style jsx>{`
                .transition-colors {
                    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-effect:hover {
                    background-color: #e2e6ea !important; /* Lighter gray on hover for inactive items */
                    color: #000 !important;
                }
            `}</style>
        </div>
    );
}